import React, { type ReactNode, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "../../utils/constants";
import useAuth from "../../hooks/useAuth";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";

interface GuestRouteProps {
  children: ReactNode;
  redirectPath?: string;
  allowOnboarding?: boolean;
}

const defaultRedirectPath = ROUTES.ROOT.HOME;

function GuestRoute({
  children,
  redirectPath = defaultRedirectPath,
  allowOnboarding = false,
}: GuestRouteProps): ReactElement {
  const { isLoggedIn } = useAuth();
  const { isOnboarding } = useOnboardingSteps();

  if (isLoggedIn && !(allowOnboarding && isOnboarding)) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}

export { GuestRoute };
